
import {Component, Vue} from 'vue-property-decorator';
import {IExternalData} from '@/interfaces/external-data';
import {rules} from '@/utils';
import {
  dispatchCreateExternalData,
  dispatchExternalDataFileUpload,
  dispatchUpdateExternalData,
} from '@/store/admin/actions';
import {readAdminExternalData, readAdminExternalDataList} from '@/store/admin/getters';
import {dispatchGetExternalData} from '@/store/main/actions';
import {readExternalData} from '@/store/main/getters';
import DefaultHelp from '@/components/tooltips/DefaultHelp.vue';
import DynamicTable from '@/components/datatables/DynamicTable.vue';
// @ts-ignore
import XLSX from 'xlsx';

@Component({
  components: {DynamicTable, DefaultHelp},
})
export default class CRUDExternalData extends Vue {
  private CEDTitle: string = `${this.$t('crud.create')} ${this.$t('external_data')}`;
  private csvFile: any = null;
  private objectHeaders: any = null;
  private objectValues: any = [];
  private valid: boolean = true;
  private rules: any = rules;
  private externalDataID: number = -1;

  private externalData: IExternalData = {} as IExternalData;

  public async mounted() {
    this.externalDataID = this.$router.currentRoute.params.id as unknown as number;
    if (this.externalDataID > 0) {
      if (readAdminExternalDataList(this.$store).length === 0) {
        await dispatchGetExternalData(this.$store, this.externalDataID);
        this.externalData = await readExternalData(this.$store) as IExternalData;
      } else {
        this.externalData = await readAdminExternalData(this.$store)(+this.externalDataID) as IExternalData;
      }
      this.CEDTitle = `${this.$t('crud.update')} ${this.$t('external_data')}`;


      if (this.externalData && this.externalData.headers) {
        await this.externalData.headers.forEach((item) => {
          this.objectHeaders.push({text: item, align: 'start', sortable: false, value: item});
        });
        this.objectValues = Object.assign([], this.externalData.values);
      }
    } else {
      this.externalData = {} as IExternalData;
      this.externalDataID = 0;
    }
  }

  public beforeRouteLeave(to, from, next) {
    this.externalData = {} as IExternalData;
    this.CEDTitle = `${this.$t('crud.create')} ${this.$t('external_data')}`;
    this.externalDataID = 0;
    this.csvFile = null;
    this.objectHeaders = [];
    this.objectValues = [];
    next();
  }

  private async saveData() {
    const form: any = this.$refs.form_crud_ed;
    if (await form.validate()) {
      // this.externalData.values = this.objectValues;
      if (this.externalDataID > 0) {
        if (await dispatchUpdateExternalData(this.$store, this.externalData)) {
          this.$router.push({name: 'main-admin-external-data-list'});
        }
      } else {
        if (await dispatchCreateExternalData(this.$store, this.externalData)) {
          this.$router.push({name: 'main-admin-external-data-list'});
        }
      }

    }
  }

  private cancel() {
    this.$router.back();
  }

  private reset() {
    // @ts-ignore
    this.$refs.form_crud_ed.reset();
  }

  private async loadFromCsv() {
    const fr = new FileReader();
    fr.onload = (e) => {
      // @ts-ignore
      const [headerLine, ...rows] = e.target.result.toString().split('\n');
      const headers = headerLine.split(/[,;]+/);

      this.externalData.headers = headers;

      headers.forEach((item) => {
        this.objectHeaders.push({text: item, align: 'start', sortable: false, value: item});
      });

      this.objectValues = rows
          .filter((item) => {
            return item !== '';
          })
          .map((row) => {
            const values = row.split(/[,;]+/);
            return headers.reduce((object, curr, i) => (object[curr] = values[i], object), {});
          });

    };
    fr.readAsText(this.csvFile, 'UTF-8');
  }

  private async loadFromXls() {
    const fr = new FileReader();
    fr.onload = (e) => {
      // @ts-ignore
      const data = e.target.result;

      const workbook = XLSX.read(data, {
        type: 'binary',
      });
      workbook.SheetNames.forEach((sheet) => {
        const rowObject = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheet],
        );
        const jsonObject = JSON.stringify(rowObject);
      });
    };
    fr.readAsBinaryString(this.csvFile);
  }

  private async loadFileInTable(val) {
    this.externalData.headers = [];
    this.externalData.values = [];
    this.objectHeaders = [];
    // this.objectValues = [];
    if (!this.csvFile) {
      console.log('No file selected');
      return;
    }

    if (await dispatchExternalDataFileUpload(this.$store, this.csvFile)) {
      const cExternalData = readExternalData(this.$store) as IExternalData;
      this.externalData.headers = cExternalData.headers;
      this.externalData.values = cExternalData.values;
      if (this.externalData?.headers) {
        this.externalData.headers.forEach((item) => {
          this.objectHeaders.push({text: item, align: 'start', sortable: false, value: item});
        });
      }
    }

    // if (this.isXlsFile) {
    //   await this.loadFromXls();
    // } else {
    //   await this.loadFromCsv();
    // }


  }
}
